module.exports = __webpack_public_path__ + "img/sv.01887b79.svg";